"use client";

import React, { useEffect, useState } from 'react';
import { useSWRConfig } from 'swr';
import ConsentDialog from '@/features/consent/components/consent-dialog';
import { onConsentRequired } from '@/features/consent/utils/consent-events';
import type { TConsentStatus } from '@/features/consent/types';

// Один слушатель на кабинет: 403 `consent_required` может прилететь из любого
// запроса — в том числе когда фотограф начал загрузку в одной вкладке, а согласие
// не закончил в другой.
export default function ConsentDialogHost()
{
  const { mutate } = useSWRConfig();

  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState<TConsentStatus>('not_started');

  useEffect(() => onConsentRequired((consent) => {
    setStatus(consent?.status ?? 'not_started');
    setOpen(true);
  }), []);

  const handleSigned = () => {
    setOpen(false);
    // Состояние согласия едет в /api/user — обновляем, чтобы быстрый путь гейта
    // не отправлял фотографа в модалку повторно.
    mutate('/api/user');
  }

  return (
    <ConsentDialog
      open={open}
      onOpenChange={setOpen}
      status={status}
      onSigned={handleSigned}
    />
  );
}
